import React from "react";
import { Formik } from "formik";
import { TextField, withStyles, Button, InputLabel, FormControl, Typography, Select, MenuItem, FormHelperText, CircularProgress, Paper } from "@material-ui/core";
import * as Yup from "yup";
import { ThemeProvider } from '@material-ui/styles';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { BackButton, isSuperUser } from '../../sc-utilities';
import { createMuiTheme } from '@material-ui/core';
import {getDateFormat} from "../../sc-utilities/date";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    rootEdit: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },

    submit: {
        width: "100%",
        marginTop: "10px",
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    formControl: {
        width: "100%"
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    }
});
const defaultMaterialThemeAdmin = createMuiTheme({
    palette: {
        primary: { 500: '#e62440' }
    }
});
const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: { 500: '#7dc5e2' }
    }
});
const TrialVoucherForm = props => {
    const { classes, formSettings, create, initialValues, handleSubmit, translations, plans } = props;
    return (
        <Paper className={classes.root}>
            {BackButton(translations, classes.customTooltip)}
            <Formik
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, setFieldValue, handleChange, handleBlur, handleSubmit } = formikProps;

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <ThemeProvider theme={isSuperUser() ? defaultMaterialThemeAdmin : defaultMaterialTheme}>
                                <FormHelperText>{translations['please_select_expiry_date'] || 'Please select expiry date'}</FormHelperText>
                                <KeyboardDatePicker
                                    clearable
                                    name={'ExpiryDate'}
                                    onBlur={handleBlur}
                                    error={!!(errors.ExpiryDate && touched.ExpiryDate)}
                                    onChange={(date) =>
                                        setFieldValue("ExpiryDate", date)
                                    }
                                    value={values.ExpiryDate !== "" ? values.ExpiryDate : null}
                                    margin={"dense"}
                                    onAccept={date => setFieldValue("ExpiryDate", date)}
                                    fullWidth={true}
                                    format={getDateFormat()}
                                />
                            </ThemeProvider>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations['plan_type_text'] || "Please select plan"}</InputLabel>
                                <Select
                                    name="PlanID"
                                    label={translations['plan'] || 'Plan'}
                                    margin={"dense"}
                                    value={values.PlanID}
                                    onChange={handleChange}
                                >
                                    {(plans ? plans : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {create ?
                                <>
                                    <TextField
                                        name="NumberOfVouchers"
                                        type='number'
                                        value={values.NumberOfVouchers}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={!!(errors.NumberOfVouchers && touched.NumberOfVouchers)}
                                        placeholder={translations['number_of_vouchers'] || 'Number of Vouchers'}
                                        label={translations['number_of_vouchers'] || 'Number of Vouchers'}
                                        margin={"dense"}
                                        fullWidth={true}
                                    />
                                    <TextField
                                        name="Description"
                                        value={values.Description}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={!!(errors.Description && touched.Description)}
                                        placeholder={translations['description'] || 'Description'}
                                        label={translations['description'] || 'Description'}
                                        margin={"dense"}
                                        fullWidth={true}
                                    />
                                    <TextField
                                        name="Emails"
                                        value={values.Emails}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={!!(errors.Emails && touched.Emails)}
                                        placeholder={translations['receivers'] || 'Receivers'}
                                        label={translations['receivers'] || 'Receivers'}
                                        margin={"dense"}
                                        fullWidth={true}
                                    />
                                    <FormHelperText>{`${translations['split_emails'] || 'Please, split emails with '}";"`}</FormHelperText>
                                </> : null}
                            {formSettings.ButtonSubmit ? (
                                <Button
                                    className={classes.submit}
                                    variant="contained"
                                    color={formSettings.ButtonSubmit.Color}
                                    type="submit"
                                    disabled={isSubmitting || !(isValid && dirty)}
                                >
                                    {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                </Button>
                            ) : null}
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};

export default withStyles(styles, { withTheme: true })(TrialVoucherForm);
